/* rs-global.js - the four always-on RareSeeds handlers that layout/theme.liquid used to carry as inline <script>
   blocks after the footer group (PLP quick-add pill + Swish add-to-cart, card hover carousel, card audio, card video).
   launch readiness pass 2, 2026-09-24: moved here verbatim, in the same order, so ~9.5 KB is cached instead of parsed on every page.
   Intended loader (same position in theme.liquid, in place of the four <script> blocks):
     <script src="{{ 'rs-global.js' | asset_url }}" defer></script>
   All four are delegated document-level listeners guarded against double-binding; `defer` runs them after parse,
   before DOMContentLoaded - rsAjaxAdd is only ever invoked from user events, so nothing calls it earlier. */

/*
RareSeeds: PLP "+ $price" pill adds to cart via AJAX and opens the cart
drawer (live behavior) instead of POSTing to /cart and leaving the page.
Falls back to the normal form submit if the fetch fails.

Also handles Swish's wishlist "Add to Cart" (.wk-form), added 2026-08-28.
The app ships a plain <form action="/cart/add" method="post">, so clicking
it navigated away to /cart — inconsistent with the rest of the site, and
it costs the shopper their place in their own wishlist.

Swish is intercepted on CLICK, in the capture phase, not on submit: the app
submits its form programmatically, and a programmatic form.submit() does
NOT fire a submit event, so a submit listener never sees it. Capture phase
also lets us stop the app's own click handler before it runs. Its form
carries the same [name=id] / [name=quantity] fields the pill form uses, so
both share one add routine and the wishlist gets the cart toast for free.
*/
(function () {
  function rsAjaxAdd(form, btn) {
    var idField = form.querySelector('[name="id"]');
    if (!idField) { form.submit(); return; }
    if (btn) btn.disabled = true;
    var payload = {
      id: parseInt(idField.value, 10),
      quantity: parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1,
      sections: ['cart-ajax']
    };
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: json } }));
        /* drawer no longer auto-opens — rs-cart-toast confirms instead */
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  /* PLP "+ $price" pill — a normal form, so the submit event is enough.
     Capture phase (2026-10-19): Shopify's pixel manager has its own submit listener on
     every /cart/add form and emits add_to_cart unless the event is already
     default-prevented when it runs, then counts the fetch again — a document-level
     bubble listener ran too late, so GA4/Meta logged every pill click twice. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('rs-card-add-form')) return;
    e.preventDefault();
    rsAjaxAdd(form, form.querySelector('.rs-card-add'));
  }, true);

  /* PLP pill on a MULTI-VARIANT product — not a form at all, because the
     pill has no way to know which size/colour the shopper wants. Open the
     card's quick-add modal so they pick one; if the card has no quick-add
     (it is hidden when the grid renders the stock add-to-cart component),
     fall back to the product page. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rs-choose-variant]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.grid-product');
    var trigger = card && card.querySelector('.js-modal-open-quick-add');
    var url = btn.dataset.productUrl;

    if (!trigger) {
      if (url) window.location.href = url;
      return;
    }

    /* The trigger lives in .grid-product__actions, which is display:none
       below 768px (see overrides.css) -- the pill is the only add
       affordance on the mobile PLP. A programmatic click still fires on a
       hidden element, but rather than assume the modal renders from one,
       confirm it actually opened and fall back to the PDP if it did not.
       Either way the shopper lands somewhere they can pick a size. */
    trigger.click();
    setTimeout(function () {
      var holder = document.querySelector('[data-tool-tip-content]');
      var opened = holder && holder.querySelector('[name="add"]') &&
        holder.getBoundingClientRect().width > 0;
      if (!opened && url) window.location.href = url;
    }, 1200);
  });

  /* Swish wishlist "Add to Cart" — capture-phase click, see comment above. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.wk-cta-button');
      if (!btn) return;
      var form = btn.closest('form.wk-form');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      rsAjaxAdd(form, btn);
    },
    true
  );
})();

/*
RareSeeds: hover image carousel controller. Delegated + guarded so it binds
once no matter how many cards render list.product-card. Cycles .rs-card-slide
overlays over the featured image; index 0 = featured (no overlay active).
*/
(function () {
  if (window.__rsCardCarouselInit) return;
  window.__rsCardCarouselInit = true;
  function step(wrap, dir) {
    var slides = wrap.querySelectorAll('.rs-card-slide');
    if (!slides.length) return false;
    var total = slides.length + 1; /* 0 = featured, 1..n = overlays */
    var cur = parseInt(wrap.getAttribute('data-rs-slide') || '0', 10);
    cur = (cur + dir + total) % total;
    wrap.setAttribute('data-rs-slide', String(cur));
    for (var i = 0; i < slides.length; i++) slides[i].classList.toggle('is-active', i === cur - 1);
    return true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rs-card-prev],[data-rs-card-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.grid-product__image-wrap');
    if (wrap) step(wrap, btn.hasAttribute('data-rs-card-next') ? 1 : -1);
  });
  /* 2026-10-19 (John: "we used to be able to scroll through product images with a swipe on the PLP ... make it so we
     can do both"): on touch screens a horizontal swipe ON A CARD'S PHOTO steps that card's images; a swipe anywhere
     else still turns the collection page (assets/rs-concept-browse.js yields with the same test: a touch that starts
     inside the photo box of a card that has slides). The card's full-cover link sits above the photo, so the touch
     target is that <a>; the photo box is found from it and the point tested against its rect. Vertical movement
     first = the page scroll, untouched. A swipe suppresses the link's click that iOS fires after a short drag. */
  function cardPhoto(target, x, y) {
    var link = target && target.closest ? target.closest('.grid-item__link') : null; if (!link) return null;
    /* 2026-10-27 (post-go-live audit DTU-002): the image-only 'Small' density hides the arrows and dots
       (assets/overrides-collection.css), so a thumbnail there must not swipe either - a swipe with no
       single-pointer alternative is the WCAG 2.5.1 gap PLA-032 closed. In that view a touch on a card is
       a plain tap through to the PDP, where the whole gallery is. */
    if (link.closest('.collection-grid[data-view="xsmall"]')) return null;
    /* 2026-10-30 (John, from the New Introductions grid on his phone: swiping Magpie Bean's photo "takes you to the
       next collection"): a card with ONE image has no slides, and until now that meant the touch was not the
       card's - so the swipe fell through to the page-turn and left the collection. A finger on a product photo
       is never a request to change collection: the photo box claims the touch whether or not it has slides;
       step() already does nothing when there is nothing to step to. */
    var wrap = link.querySelector('.grid-product__image-wrap'); if (!wrap) return null;
    var r = wrap.getBoundingClientRect(); return (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) ? wrap : null;
  }
  window.__rsCardPhotoAt = cardPhoto;
  var w = null, x0 = 0, y0 = 0, lockedH = false, dead = false;
  document.addEventListener('touchstart', function (e) {
    w = null; if (!e.touches || e.touches.length !== 1) return;
    var t = e.touches[0]; w = cardPhoto(e.target, t.clientX, t.clientY); if (!w) return;
    x0 = t.clientX; y0 = t.clientY; lockedH = false; dead = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!w || dead || !e.touches || !e.touches.length) return;
    var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
    if (!lockedH) { if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return; if (Math.abs(dy) > Math.abs(dx)) { dead = true; return; } lockedH = true; }
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!w) return; var wrap = w; w = null; if (!lockedH || dead) return;
    var t = e.changedTouches && e.changedTouches[0]; var dx = t ? t.clientX - x0 : 0; if (Math.abs(dx) < 40) return;
    step(wrap, dx < 0 ? 1 : -1); wrap.__rsSwipedAt = Date.now();
  }, { passive: true });
  document.addEventListener('touchcancel', function () { w = null; }, { passive: true });
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.grid-item__link'); if (!link) return;
    var wrap = link.querySelector('.grid-product__image-wrap'); if (wrap && wrap.__rsSwipedAt && Date.now() - wrap.__rsSwipedAt < 700) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();

/*
RareSeeds: product-card audio description (PLP), matching live's small play
control after the price pill. Lives here rather than in rs-card-audio.liquid
so a 24-tile grid ships ONE copy of this handler instead of 24.

Only one clip plays at a time, page-wide — that also covers the card audio
vs the PDP player, which share nothing but should never overlap. Click is
stopped so it does not follow the card's overlay product link. If the file
is missing the button removes itself, same rule as the PDP player.
*/
(function () {
  if (window.__rsCardAudio) return; window.__rsCardAudio = true;

  function sync(wrap, playing) {
    var btn = wrap.querySelector('.rs-card-audio__btn');
    var play = wrap.querySelector('.rs-card-audio__icon--play');
    var pause = wrap.querySelector('.rs-card-audio__icon--pause');
    /* toggleAttribute, not .hidden: these are <svg> elements and the
       hidden IDL property lives on HTMLElement, which SVGElement does
       not inherit -- assigning .hidden on an svg silently sets a useless
       expando, so the attribute never changes and the icon never swaps. */
    if (play) play.toggleAttribute('hidden', playing);
    if (pause) pause.toggleAttribute('hidden', !playing);
    wrap.classList.toggle('is-playing', playing);
    if (!btn) return;
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    var label = btn.getAttribute('aria-label') || '';
    var name = label.replace(/^(Play|Pause) audio description for /, '');
    btn.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' audio description for ' + name);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rs-card-audio__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('[data-rs-card-audio]');
    var audio = wrap && wrap.querySelector('.rs-card-audio__el');
    if (!audio) return;
    if (audio.paused) {
      document.querySelectorAll('.rs-card-audio__el, .rs-pdp-audio__el').forEach(function (o) {
        if (o !== audio) o.pause();
      });
      audio.play().catch(function () { sync(wrap, false); });
    } else {
      audio.pause();
    }
  });

  /* Track the element's real state; capture phase because media events do not bubble. */
  ['play', 'pause', 'ended'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var el = e.target;
      if (!el.classList || !el.classList.contains('rs-card-audio__el')) return;
      var wrap = el.closest('[data-rs-card-audio]');
      if (wrap) sync(wrap, evt === 'play');
    }, true);
  });

  /* Nothing behind the filename -> drop the control rather than leave a dead one. */
  document.addEventListener('error', function (e) {
    var el = e.target;
    if (!el || !el.tagName) return;
    var isSource = el.tagName === 'SOURCE' && el.parentElement
      && el.parentElement.classList.contains('rs-card-audio__el');
    var isAudio = el.classList && el.classList.contains('rs-card-audio__el');
    if (!isSource && !isAudio) return;
    var wrap = el.closest('[data-rs-card-audio]');
    if (wrap) wrap.remove();
  }, true);
})();

/*
RareSeeds: inline product-card video. Play button reveals + plays the card's
video; only ONE plays at a time (starting/resuming one reverts any other).
Tap on the button is stopped so it doesn't follow the card's product link.
*/
(function () {
  if (window.__rsCardVideo) return; window.__rsCardVideo = true;
  var current = null;
  function revert(v) {
    if (!v) return;
    try { v.pause(); } catch (e) {}
    v.classList.remove('is-active');
    if (v.__btn) v.__btn.hidden = false;
  }
  function activate(v) {
    if (current && current !== v) revert(current);
    current = v;
    v.classList.add('is-active');
    if (v.__btn) v.__btn.hidden = true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rs-card-video-play]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var card = btn.closest('[data-product-grid-item]') || btn.closest('.grid-item__link') || btn.closest('.grid-product');
    var video = card && card.querySelector('[data-rs-card-video]');
    if (!video) return;
    video.__btn = btn;
    if (!video.dataset.loaded) { video.src = video.dataset.src; video.dataset.loaded = '1'; }
    activate(video);
    var p = video.play(); if (p && p.catch) p.catch(function () {});
  });
  /* media events don't bubble -> capture phase. Enforce single-active on any play
     (incl. native resume); reset a video to its thumbnail when it ends. */
  document.addEventListener('play', function (e) {
    var v = e.target; if (!v.matches || !v.matches('[data-rs-card-video]')) return;
    activate(v);
  }, true);
  document.addEventListener('ended', function (e) {
    var v = e.target; if (!v.matches || !v.matches('[data-rs-card-video]')) return;
    revert(v); if (current === v) current = null;
  }, true);
})();

/*
RareSeeds 2026-10-21 (PLA-025): PDP gallery slide hydration. Every image slide after
the first renders with its real src/srcset parked in data-src/data-srcset behind a
transparent 1x1 gif (snippets/product.gallery.media.liquid, see the comment there):
loading="lazy" could not defer them because Flickity's wrap-around puts the previous
and next slide exactly edge-adjacent to the clipped slider viewport, which Chrome's
lazy-load observer counts as intersecting. A slide gets its real sources when
  - at least 1% of it is actually visible (the phone peek of slide 2, a swipe or arrow
    in progress, a variant selecting its image) — threshold 0.01 so edge-adjacent
    (ratio 0) never fires, 200px vertical margin so the stacked layout prefetches; or
  - the shopper first touches/clicks/keys inside the gallery: everything in that
    gallery hydrates at once so the swipe target is ready.
Galleries injected later (quick-add modal section render) are picked up by a childList
observer. No-IO browsers hydrate immediately (= the old behaviour).
*/
(function () {
  if (window.__rsGalleryHydrate) return; window.__rsGalleryHydrate = true;
  var SEL = '[data-product-photos] img[data-src]';
  function hydrate(img) {
    if (!img.hasAttribute('data-src')) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    if (io) io.unobserve(img);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting && entries[i].intersectionRatio > 0) hydrate(entries[i].target);
    }
  }, { rootMargin: '200px 0px', threshold: 0.01 }) : null;
  function watch(root) {
    var imgs = root.querySelectorAll(SEL);
    for (var i = 0; i < imgs.length; i++) { if (io) io.observe(imgs[i]); else hydrate(imgs[i]); }
  }
  ['pointerdown', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var scope = e.target && e.target.closest ? e.target.closest('product-images, [data-product-photos]') : null;
      if (!scope) return;
      var imgs = scope.querySelectorAll(SEL);
      for (var i = 0; i < imgs.length; i++) hydrate(imgs[i]);
    }, { capture: true, passive: true });
  });
  watch(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var added = ms[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && n.querySelector && n.querySelector(SEL)) watch(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
